import React, { useEffect } from "react";
import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useAdminDashboardStore } from "../../store/admin/dashboardStore";
 
import { ArrowUp, ArrowDown, Users, Home } from "lucide-react";
import { InfoCard } from "../../components/InfoCard";

export const AdminDashboard = () => {
  const { loading, error, fetchData, data } = useAdminDashboardStore();

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) return <div className="flex justify-center items-center h-screen"><ProgressSpinner /></div>;
  if (error) return <div className="text-red-500 text-center mt-10">{error}</div>;
  if (!data) return <div className="text-center mt-10">Veri bulunamadı</div>;

  const dashboard = data;

  // Son 30 gün işlemlerinden toplam girdi ve çıktı
  const totalInflow = dashboard.recentTransactions
    .filter(tx => tx.type === "inflow")
    .reduce((sum, tx) => sum + tx.amount, 0);

  const totalOutflow = dashboard.recentTransactions
    .filter(tx => tx.type === "outflow")
    .reduce((sum, tx) => sum + tx.amount, 0);

  return (
    <div className="p-6">
      {/* Üst kartlar */}
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
  <InfoCard 
    title="Firmalar" 
    value={dashboard.totalFirms} 
    icon={Home} 
    bgColor="bg-indigo-500"
  />
  <InfoCard 
    title="Kullanıcı" 
    value={dashboard.totalUsers} 
    icon={Users} 
    bgColor="bg-green-500"
  />
  <InfoCard
  title="Gelir"
  value={`${totalInflow} ₺`}
  icon={ArrowDown}
  bgColor="bg-blue-500"
  label="Son 30 Gün"
/>

<InfoCard
  title="Gider"
  value={`${totalOutflow} ₺`}
  icon={ArrowUp}
  bgColor="bg-red-500"
  label="Son 30 Gün"
/>
</div>
      {/* Son işlemler tablosu */}
      <div >
        <DataTable 
        emptyMessage="Kayıt bulunamadı."
        header={<h2 className="text-xl font-bold mb-3">Son İşlemler</h2>}
        value={dashboard.recentTransactions} paginator rows={10} className="p-datatable-gridlines">
          <Column field="createdAt" header="Tarih" body={(row: any) => new Date(row.createdAt).toLocaleString()}></Column>
          <Column field="type" header="Tür"></Column>
          <Column field="amount" header="Tutar" body={(row: any) => `${row.amount} ₺`}></Column>
          <Column field="description" header="Açıklama" body={(row: any) => row.description || "-"}></Column>
        </DataTable>
      </div>
    </div>
  );
};
